import type { AttributeSourceType } from '@/types/feed/attribute';

export const ATTRIBUTE_SOURCE_TYPES = {
  PRODUCTS: 'products',
  CSV: 'csv',
  GOOGLE_SHEET: 'googleSheet',
  FEED: 'feed',
  MANUAL: 'manual'
} as const;

export function isProductAttributeSource(
  sourceType: AttributeSourceType | null | undefined
): sourceType is typeof ATTRIBUTE_SOURCE_TYPES.PRODUCTS {
  return sourceType === ATTRIBUTE_SOURCE_TYPES.PRODUCTS;
}
